import React from 'react';
import {contentProps} from'./content.props';
import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
import GoogleMap from 'react-google-maps/lib/GoogleMap';
import Marker from 'react-google-maps/lib/Marker';
import SearchBox from 'react-google-maps/lib/places/SearchBox';

const INPUT_STYLE = {
  boxSizing: 'border-box',
  MozBoxSizing: 'border-box',
  border: '1px solid transparent',
  width: 240,
  height: 32,
  marginTop: 8,
  padding: '0 12px',
  borderRadius: '1px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
  fontSize: '14px',
  outline: 'none',
  textOverflow: 'ellipses'
};

const SearchBoxExampleGoogleMap = withGoogleMap(props => (
  <GoogleMap
    options={{scrollwheel: false}}
    ref={props.onMapMounted}
    defaultZoom={15}
    center={props.center}
    onBoundsChanged={props.onBoundsChanged}
    onClick={props.onMapClick}
  >
    <SearchBox
      ref={props.onSearchBoxMounted}
      bounds={props.bounds}
      controlPosition={window.google.maps.ControlPosition.TOP_LEFT}
      onPlacesChanged={props.onPlacesChanged}
      inputPlaceholder="Type place here"
      inputStyle={INPUT_STYLE}
    />

    {props.markers.map((marker, index) => (
      <Marker position={marker.position} key={index}/>
    ))}
  </GoogleMap>
));


export class MapContentComponent extends React.Component {
  static propTypes = {
    ...contentProps
  };

  state = {
    bounds: null
  };


  handleMapMounted = this.handleMapMounted.bind(this);
  handleBoundsChanged = this.handleBoundsChanged.bind(this);
  handleSearchBoxMounted = this.handleSearchBoxMounted.bind(this);
  handlePlacesChanged = this.handlePlacesChanged.bind(this);
  handleSetCoordinate = this.handleSetCoordinate.bind(this);

  handleMapMounted(map) {
    this._map = map;
  }

  handleBoundsChanged() {
    this.setState({
      bounds: this._map.getBounds(),
      center: this._map.getCenter()
    });
  }

  handleSearchBoxMounted(searchBox) {
    this._searchBox = searchBox;
  }

  handlePlacesChanged() {
    const places = this._searchBox.getPlaces();

    // Add a marker for each place returned from search bar
    const markers = places.map(place => ({
      position: place.geometry.location
    }));

    // Set markers; set map center to first search result
    const mapCenter = markers.length > 0 ? markers[0].position : this.state.center;

    const {onChange, node} = this.props;

    onChange(node.setCoordinates({
      lat: mapCenter.lat(),
      lng: mapCenter.lng()
    }));
  }

  handleSetCoordinate(event) {
    const {onChange, node} = this.props;

    onChange(node.setCoordinates({
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    }));
  }

  render() {
    const {node} = this.props;
    return (
      <div>
        <h6>Map</h6>
      <SearchBoxExampleGoogleMap
        containerElement={
          <div style={{height: 600}}/>
        }
        mapElement={
          <div style={{height: 600}}/>
        }
        onMapClick={this.handleSetCoordinate}
        center={node}
        onMapMounted={this.handleMapMounted}
        onBoundsChanged={this.handleBoundsChanged}
        onSearchBoxMounted={this.handleSearchBoxMounted}
        bounds={this.state.bounds}
        onPlacesChanged={this.handlePlacesChanged}
        markers={[{position:node}]}
      />
      </div>
    );
  }
}

export default MapContentComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/MapContentComponent.js